import { API_BASE_URL, DEFAULT_COMPANY_ID } from './config';
import { apiFetch } from './apiFetch';

export type DivisionDto = {
  id: string;
  companyId: string;
  code: string;
  name: string;
  parentDivisionId?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type DivisionListResponse = {
  success: boolean;
  data?: {
    divisions: DivisionDto[];
  };
  error?: string;
};

export async function listDivisions(companyId = DEFAULT_COMPANY_ID, includeInactive = false): Promise<DivisionListResponse> {
  const query = new URLSearchParams({
    includeInactive: includeInactive ? 'true' : 'false',
  }).toString();

  const response = await apiFetch(`${API_BASE_URL}/api/divisions/company/${companyId}?${query}`, {
    method: 'GET',
  });

  return response.json();
}

export async function createDivision(input: {
  companyId?: string;
  code: string;
  name: string;
  parentDivisionId?: string;
}): Promise<{ success: boolean; data?: { division: DivisionDto }; error?: string }> {
  const response = await apiFetch(`${API_BASE_URL}/api/divisions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      companyId: input.companyId ?? DEFAULT_COMPANY_ID,
      code: input.code,
      name: input.name,
      parentDivisionId: input.parentDivisionId,
    }),
  });
  return response.json();
}

export async function renameDivision(
  divisionId: string,
  name: string,
  companyId = DEFAULT_COMPANY_ID,
): Promise<{ success: boolean; data?: { division: DivisionDto }; error?: string }> {
  const response = await apiFetch(`${API_BASE_URL}/api/divisions/${divisionId}/rename`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ companyId, name }),
  });
  return response.json();
}

export async function setDivisionStatus(
  divisionId: string,
  isActive: boolean,
  companyId = DEFAULT_COMPANY_ID,
): Promise<{ success: boolean; data?: { division: DivisionDto }; error?: string }> {
  const response = await apiFetch(`${API_BASE_URL}/api/divisions/${divisionId}/status`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ companyId, isActive }),
  });
  return response.json();
}

export async function reparentDivision(
  divisionId: string,
  parentDivisionId: string | null,
  companyId = DEFAULT_COMPANY_ID,
): Promise<{ success: boolean; data?: { division: DivisionDto }; error?: string }> {
  const response = await apiFetch(`${API_BASE_URL}/api/divisions/${divisionId}/parent`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ companyId, parentDivisionId }),
  });
  return response.json();
}
